module.exports = __webpack_public_path__ + "media/images/setting/icon4-356dc97888a63e4c925cbf3b895fbfb8.svg";